import { memo } from 'react';
import type { BadgeProps } from '@/src/types';
import { cn } from '@/src/utils';

const variants = {
  default: 'bg-white/5 border-white/10 text-gray-300',
  success: 'bg-green-500/10 border-green-500/20 text-green-300',
  warning: 'bg-yellow-500/10 border-yellow-500/20 text-yellow-300',
  error: 'bg-red-500/10 border-red-500/20 text-red-300',
  info: 'bg-blue-500/10 border-blue-500/20 text-blue-300',
};

function Badge({
  variant = 'default',
  children,
  className,
  icon,
  pulse = false,
}: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-2 px-3 py-1 rounded-full border text-xs font-bold tracking-widest uppercase',
        variants[variant],
        className
      )}
    >
      {pulse && (
        <span
          className={cn(
            'w-2 h-2 rounded-full animate-pulse',
            variant === 'success' && 'bg-green-500',
            variant === 'warning' && 'bg-yellow-500',
            variant === 'error' && 'bg-red-500',
            variant === 'info' && 'bg-blue-500',
            variant === 'default' && 'bg-white'
          )}
        />
      )}
      {icon && <span>{icon}</span>}
      {children}
    </span>
  );
}

export default memo(Badge);
